import { render } from "./SaleDetailTabsPanel.vue?vue&type=template&id=7c6112df&scoped=true"
import script from "./SaleDetailTabsPanel.vue?vue&type=script&lang=js"
export * from "./SaleDetailTabsPanel.vue?vue&type=script&lang=js"

import "./SaleDetailTabsPanel.vue?vue&type=style&index=0&id=7c6112df&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c6112df"]])

export default __exports__